import Papa from 'papaparse'

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.[\]{}()?"!@#%&/,><':;|_~+`=-])[A-Za-z\d^$*.[\]{}()?"!@#%&/,><':;|_~+`=-]{8,}$/
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const usernameRegex = /^[a-zA-Z0-9._-]+$/

const validator = (file, rules) => {
  return new Promise(resolve => {
    const { requiredFields, identifiers } = rules
    let rowNum = 1

    Papa.parse(file, {
      delimiter: ',',
      header: true,
      skipEmptyLines: true,
      step: ({ data, errors }, parser) => {
        const fields = Object.keys(data)
        const username = data.Username
        const email = data.Email
        const password = data.Password

        // Check required fields exists and contain a value.
        for (const requiredField of requiredFields) {
          const fieldValue = data[requiredField]

          if (!fields.includes(requiredField)) {
            console.debug('CSV Validation aborted:', 'missing-header')
            resolve({
              code: 'missing-header',
              message: `The CSV file must have the ${requiredField} header`
            })
            parser.abort()
          }

          if (!fieldValue) {
            console.debug('CSV Validation aborted:', 'missing-attribute')
            resolve({
              code: 'missing-attribute',
              message: `Missing required value for "${requiredField}" on row ${rowNum}.`
            })
            parser.abort()
          }
        }

        // Validate an identifier field is provided
        if (!identifiers.some(field => data[field])) {
          console.debug('CSV Validation aborted', 'missing-attribute')
          resolve({
            code: 'missing-attribute',
            message: `Missing ${identifiers.join(' or ')} on row ${rowNum}.`
          })
          parser.abort()
        }

        // Validate Password format
        if (password && !passwordRegex.test(password)) {
          const allowedPasswordChars =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789^$*.[]{}()?-"!@#%&/,><\':;|_~+=`'
          const invalidPasswordChars = [...password].filter(
            ch => !allowedPasswordChars.includes(ch)
          )
          if (invalidPasswordChars.length > 0) {
            console.debug('CSV Validation aborted', 'invalid-password')
            resolve({
              code: 'invalid-password',
              message: `Invalid Password on row ${rowNum}: password cannot contain the following invalid character(s): '${invalidPasswordChars.join(
                "', '"
              )}'.`
            })
            parser.abort()
          }
          resolve({
            code: 'invalid-password',
            message: `Invalid Password on row ${rowNum}: password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.`
          })
          parser.abort()
        }

        // Validate Email format
        if (email && !emailRegex.test(email)) {
          console.debug('CSV Validation aborted', 'invalid-email')
          resolve({
            code: 'invalid-email',
            message: `Invalid Email on row ${rowNum}: ${email} does not have use a valid email format.`
          })
          parser.abort()
        }

        // Validate Username format
        if (username && !usernameRegex.test(username)) {
          const allowedUsernameChars =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789._-'
          const invalidUsernameChars = [...username].filter(
            ch => !allowedUsernameChars.includes(ch)
          )
          if (invalidUsernameChars.length > 0) {
            console.debug('CSV Validation aborted', 'invalid-username')
            resolve({
              code: 'invalid-username',
              message: `Invalid Username on row ${rowNum}: username cannot contain the following invalid character(s): '${invalidUsernameChars.join(
                "', '"
              )}'.`
            })
            parser.abort()
          }
          resolve({
            code: 'invalid-username',
            message: `Invalid Username on row ${rowNum}: username should only contain letters, numbers, periods, underscores, and hyphens.`
          })
          parser.abort()
        }

        rowNum++
        if (errors.length) {
          console.debug('CSV Error', errors)
          resolve({
            code: errors[0].code,
            message: errors[0].message
          })
          parser.abort()
        }
      },
      complete: () => {
        console.debug('CSV Validation complete')
        resolve(rowNum)
      }
    })
  })
}

export default validator
